<style lang="scss" scoped>
@import "$vars";
.menu {
  height: auto;
  max-height: 200px;
  overflow: auto;
  li:hover {
    background: #e1e1e1;
    cursor: pointer;
  }
}
.patient-input {
  border: none;
  border-bottom: 1px solid $border-color-dark;
  margin-bottom: 20px;
  padding-bottom: 5px;
  .form-input {
    font-size: $unit-6;
  }
}
</style>

<template>
  <div class="form-autocomplete" :class="inputValue ? 'has-success' : ''" >
    <div class="form-autocomplete-input form-input has-icon-left has-icon-right" :class="inputClass">
      <input
        v-model="inputValue.name"
        @input="resetItem()"
        :disabled="disabled"
        v-if="inputValue"
        class="form-input"
        type="text"
        :placeholder="placeholder"
      >
      <input v-model="searchTerm" @input="$emit('typed', searchTerm)" v-else class="form-input" type="text" @focus="focused = true" :placeholder="placeholder"  :class="inputClass"  :disabled="disabled">
      <i v-if="loading && !inputValue" class="form-icon loading"></i>
      <i v-else-if="inputValue && !disabled" class="form-icon icon icon-cross clickable" @click="resetValues(); $emit('cleared', true)"></i>
      <i v-else-if="!loading && searchTerm && !disabled" class="form-icon icon icon-cross clickable" @click="resetValues(); $emit('cleared', true)"></i>
    </div>
    {{editedValue}}
    <ul class="menu" v-if="filteredList.length > 0 && searchTerm.length > 0 && !inputValue">
      <li
        @click="selectItem(item)"
        v-for="(item, $index) in filteredList"
        :key="'item'+$index"
        class="menu-item"
      >{{item.name}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: [
    'list',
    'model',
    'fields',
    'endpoint',
    'storeType',
    'format',
    'returnFormat',
    'value',
    'reset',
    'placeholder',
    'disabled',
    'options',
    'inputClass',
    'defaultFilter',
    'newFilter',
    'disableLocal',
    'pk',
    'editedValue'
  ],
  data () {
    return {
      localList: [],
      filteredList: [],
      inputValue: null,
      loading: false,
      tick: 0,
      searchTerm: null,
      startTimer: null,
      searching: false,
      focused: false
    }
  },
  mounted () {
    if (this.value) {
      this.searchTerm = this.value
    }
    if (this.storeType) {
      this.localList = this.$store.getters.getAutocomplete(this.storeType)
    }
  },
  computed: {
    getPk () {
      return this.pk || 'id'
    }
  },
  watch: {
    editedValue (next, prev) {
      console.log('next', next)
      if (next) {
        this.inputValue = { ...next }
      }
    },
    value (next, prev) {
      if (next) {
        this.inputValue = {
          id: 0,
          name: next
        }
      }
    },
    searchTerm: function (next, prev) {
      if (!this.endpoint && this.focused) {
        this.searchLocal()
        this.localList = this.options
        this.tick = 2
        this.loading = false
        this.searching = false
      } else {
        if (this.disableLocal) {
          this.$emit('input', next)
          this.filteredList = []
        }
        if ((next || []).length > 2 && this.focused) {
          this.searchLocal()
          this.loading = true
          this.toggleTick(true)
        }
      }
    },
    tick: function (next, prev) {
      if (next > 1) {
        this.fetchList()
      }
    }
  },
  methods: {
    resetValues () {
      this.searchTerm = ''
      this.inputValue = ''
      this.$emit('change', null)
    },
    selectItem (item) {
      this.inputValue = this.fn_COPY_OBJECT(item)
      this.$emit('change', this.convert2Format(item, this.returnFormat))
      if (this.reset) {
        this.localList = []
        this.filteredList = []
        this.inputValue = null
        this.loading = false
        this.tick = 0
        this.searchTerm = ''
        this.startTimer = null
        this.searching = false
      }
    },
    resetItem () {
      this.inputValue = null
      this.$emit('change', null)
    },
    arrayUnique (original, target) {
      let arr = []
      let arrIds = []
      for (let item of original) {
        arr.push(item)
        arrIds.push(item[this.getPk])
      }
      for (let item of target) {
        if (arrIds.indexOf(item[this.getPk]) === -1) {
          arr.push(item)
        }
      }
      return arr
    },
    deDupe (arr) {
      let newarr = []
      let ids = []
      for (let item of arr) {
        if (ids.indexOf(item.id) === -1) {
          ids.push(item.id)
        }
      }
      for (let item of arr) {
        if (ids.indexOf(item.id) > -1) {
          newarr.push(item)
          ids.splice(ids.indexOf(item.id), 1)
        }
      }
      return newarr
    },
    convert2Format (item, format) {
      if (!format) {
        return item.id
      } else if (format === 'object') {
        return ('obj' in item ? item.obj : item)
      }
      let arr = format.split(/{(.*?)}/g)
      let str = ''
      for (let part of arr) {
        if (part.indexOf('$') > -1) {
          str = str + item[part.replace('$', '')]
        } else {
          str = str + part
        }
      }
      return str
    },
    searchLocal (api) {
      if (this.disableLocal) {
        return
      }
      const self = this
      function hasSubArray (master, sub) {
        return sub.every(function (i) {
          return function (v) {
            let n = 0
            for (let item of master) {
              if (self.fn_REMOVE_ACCENTS(item).indexOf(self.fn_REMOVE_ACCENTS(v)) > -1) {
                n = 1
              }
            }
            return n
          }
        }(0))
      }
      this.$emit('isEmpty', -1)
      let matched = []
      let searchTerm = this.searchTerm.search(' ') > -1 ? this.searchTerm.toUpperCase().split(' ') : this.searchTerm.toUpperCase()
      for (let item of this.localList) {
        let words = this.convert2Format(item, this.format).toUpperCase().split(' ')
        if (this.storeType === 'medicament') { // BUSCA POR PRINCÍPIOS ATIVOS
          for (let principle of item.active_principles) {
            let split = principle.name.split(' ')
            for (let splitted of split) {
              words.push(splitted)
            }
          }
        }
        if (Array.isArray(searchTerm)) {
          searchTerm = searchTerm.filter((v) => {
            return v.length > 0 ? v : false
          })
          // console.log(words, searchTerm)
          if (hasSubArray(words, searchTerm)) {
            let result = {
              id: item[this.getPk],
              name: this.convert2Format(item, this.format),
              obj: item
            }
            matched.push(result)
          }
        } else {
          for (let preWord of words) {
            let word = this.fn_REMOVE_ACCENTS(preWord)
            // console.log(word, this.fn_REMOVE_ACCENTS(searchTerm))
            if (word.search(this.fn_REMOVE_ACCENTS(searchTerm)) > -1) { // loop instead of includes() because of toUpperCase
              let result = {
                id: item[this.getPk],
                name: this.convert2Format(item, this.format),
                obj: item
              }
              matched.push(result)
            }
          }
        }
      }
      if (matched.length === 0 && api) {
        this.$emit('isEmpty', 1)
      }
      // console.log(this.filteredList, matched)
      this.filteredList = this.deDupe(matched)
    },
    fetchList () {
      if (!this.endpoint) {
        return
      }
      let search = ''
      let fields = this.fields
      let searchTerm = this.searchTerm
      this.searching = true
      if (!Array.isArray(this.fields)) {
        fields = [this.fields]
      }
      for (let field of fields) {
        search = search + field + '=' + searchTerm + '&'
      }
      if (this.newFilter) {
        search = ''
        for (let field of fields) {
          search = `${search}${field}=${searchTerm}&`
        }
      }
      this.toggleTick()
      this.$http.get(`/${this.endpoint}?itensPerPage=20&${search}${this.defaultFilter || ''}`, this.$store.getters.getAuthHeader).then(
        (res) => {
          let data = res.data
          if (data.data) {
            data = data.data
          }
          this.localList = this.arrayUnique(this.fn_COPY_ARRAY(this.localList), data)
          if (this.storeType) {
            this.$store.dispatch('setAutocomplete', {
              type: this.storeType,
              data: this.localList
            })
          }
          this.loading = false
          this.searching = false
          if (this.disableLocal) {
            // console.log('data \n', data)
            this.filteredList = data
            return
          }
          this.searchLocal(1)
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    },
    toggleTick (v) {
      const self = this
      if (this.startTimer && v) {
        clearInterval(this.startTimer)
        this.startTimer = setInterval(function () {
          self.tick = self.tick + 1
        }, 1000)
        return
      }
      if (v) {
        this.startTimer = setInterval(function () {
          self.tick = self.tick + 1
        }, 1000)
      } else {
        this.tick = 0
        clearInterval(this.startTimer)
        this.startTimer = null
        this.$store.getters.getCancelToken.cancel('fim')
        this.$store.dispatch('setCancelToken', this.$http.CancelToken.source())
      }
    }
  }
}
</script>
